export interface ProductCategoryMappingEntry {
  saleCategory: {
    aadeId?: string;
    aadeCode?: string;
    name?: string;
    description?: string;
  };
  saleCharacterisation: {
    aadeId?: string;
    aadeCode?: string;
    name?: string;
    description?: string;
  };
  vatCategory?: string;
  vatCategoryException?: string;
}

export type ProductCategoryMapping = {
  [key: number]: ProductCategoryMappingEntry;
};

/**
 * Main key is ProducCategory.aadeId/aadeCode (aadeId, aadeCode has the same value)
 */
export const PRODUCT_CATEGORY_PRE_SELECT_MAPPING: ProductCategoryMapping = {
  // Εμπορεύματα
  0: {
    saleCategory: {
      aadeId: 'category1_1',
      aadeCode: '1.1',
      name: 'INCOME_FROM_PRODUCTS_SALE',
      description: 'Έσοδα από Πώληση Εμπορευμάτων',
    },
    saleCharacterisation: {
      aadeId: 'E3_561_001',
      aadeCode: 'E3_561_001',
      name: 'SALES_GOODS_SERVICES_WHOLESALE_COMMERCIAL',
      description: 'Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών',
    },
  },
  // Προϊόντα
  1: {
    saleCategory: {
      aadeId: 'category1_2',
      aadeCode: '1.2',
      name: 'INCOME_FROM_SALE_OF_PRODUCTS',
      description: 'Έσοδα από Πώληση Προϊόντων',
    },
    saleCharacterisation: {
      aadeId: 'E3_561_001',
      aadeCode: 'E3_561_001',
      name: 'SALES_GOODS_SERVICES_WHOLESALE_COMMERCIAL',
      description: 'Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών',
    },
  },
  // Αγροτ./Βιολογ.
  2: {
    saleCategory: {
      aadeId: 'category1_2',
      aadeCode: '1.2',
      name: 'INCOME_FROM_SALE_OF_PRODUCTS',
      description: 'Έσοδα από Πώληση Προϊόντων',
    },
    saleCharacterisation: {
      aadeId: 'E3_561_001',
      aadeCode: 'E3_561_001',
      name: 'SALES_GOODS_SERVICES_WHOLESALE_COMMERCIAL',
      description: 'Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών',
    },
  },
  // Παροχή Υπηρεσιών
  3: {
    saleCategory: {
      aadeId: 'category1_3',
      aadeCode: '1.3',
      name: 'INCOME_FROM_SERVICES',
      description: 'Έσοδα από Παροχή Υπηρεσιών',
    },
    saleCharacterisation: {
      aadeId: 'E3_561_001',
      aadeCode: 'E3_561_001',
      name: 'SALES_GOODS_SERVICES_WHOLESALE_COMMERCIAL',
      description: 'Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών',
    },
  },
  // Για Λογαριασμό Τρίτων
  4: {
    saleCategory: {
      aadeId: 'category1_7',
      aadeCode: '1.7',
      name: 'INCOME_BEHALF_THIRD_PARTIES',
      description: 'Έσοδα για λογαριασμό τρίτων',
    },
    saleCharacterisation: {
      aadeId: 'E3_561_001',
      aadeCode: 'E3_561_001',
      name: 'SALES_GOODS_SERVICES_WHOLESALE_COMMERCIAL',
      description: 'Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών',
    },
  },
  // Πάγια
  5: {
    saleCategory: {
      aadeId: 'category1_4',
      aadeCode: '1.4',
      name: 'INCOME_FROM_SALE_FIXED_ASSETS',
      description: 'Έσοδα από Πώληση Παγίων',
    },
    saleCharacterisation: {
      aadeId: 'E3_880_001',
      aadeCode: 'E3_880_001',
      name: 'SALES_FIXED_ASSETS_WHOLESALE',
      description: 'Πωλήσεις Παγίων Χονδρικές',
    },
  },
  // Πρώτες ύλες
  6: {
    saleCategory: {},
    saleCharacterisation: {},
  },
  // Διάφορα
  7: {
    saleCategory: {
      aadeId: 'category1_95',
      aadeCode: '1.95',
      name: 'OTHER_INCOME_INFORMATION',
      description: 'Λοιπά Πληροφοριακά Στοιχεία Εσόδων',
    },
    saleCharacterisation: {},
  },
  // Συσκευασία Εγγυοδοσίας
  8: {
    saleCategory: {
      aadeId: 'category1_95',
      aadeCode: '1.95',
      name: 'OTHER_INCOME_INFORMATION',
      description: 'Λοιπά Πληροφοριακά Στοιχεία Εσόδων',
    },
    saleCharacterisation: {
      aadeId: 'NOE3',
      aadeCode: 'NO_E3',
      name: 'UNUSUAL_INCOME_PROFIT',
      description: 'Χωρίς τύπο Ε3',
    },
    vatCategory: '7', // 0% `aadeCode`
    vatCategoryException: '6', // (6) No vat, article 19 `aadeCode`
  },
  // Περιβαλλοντικό Τέλος
  9: {
    saleCategory: {
      aadeId: 'category1_95',
      aadeCode: '1.95',
      name: 'OTHER_INCOME_INFORMATION',
      description: 'Λοιπά Πληροφοριακά Στοιχεία Εσόδων',
    },
    saleCharacterisation: {
      aadeId: 'NOE3',
      aadeCode: 'NO_E3',
      name: 'UNUSUAL_INCOME_PROFIT',
      description: 'Χωρίς τύπο Ε3',
    },
  },
};
